import { Box, makeStyles, Typography } from "@material-ui/core";
import { ImageType, SvgImage } from "../../../images/svg";
import React from "react";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "19px",
    fontWeight: 500,
    color: "#fff",
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: 200,
    width: 200,
    backgroundColor: "#114668",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    margin: 10,
    borderRadius: 10,
  },
}));

const PlayAndStopButton = ({ onClick, isPlaying }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.box}
      onClick={() => {
        onClick(isPlaying);
      }}
    >
      <SvgImage type={isPlaying ? ImageType.Stop : ImageType.Play} />
      <Typography className={classes.title}>
        {isPlaying ? "Stop" : "Play"}
      </Typography>
    </Box>
  );
};

export default PlayAndStopButton;
